import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t        squareImg:transformedSrc(maxWidth:600, maxHeight:600, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t'], ['\n\t\t\tquery query {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t  options {\n\t\t\t\t\t\t    id\n\t\t\t\t\t\t    name\n\t\t\t\t\t\t    values\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  variants(first:100) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        id \n\t\t\t\t\t\t        title\n\t\t\t\t\t\t        priceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        compareAtPriceV2 {\n\t\t\t\t\t\t          amount\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        availableForSale\n\t\t\t\t\t\t        selectedOptions {\n\t\t\t\t\t\t          name\n\t\t\t\t\t\t          value\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t        image {\n\t\t\t\t\t\t          altText\n\t\t\t\t\t\t          thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t          productImg: transformedSrc(maxWidth:800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t        }\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:50) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 485, crop: CENTER)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t        squareImg:transformedSrc(maxWidth:600, maxHeight:600, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t']);

import React, { Component } from 'react';
import { Query, compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';

// display components
import CTAGallery from '../gallery/cta_gallery';
import CTABanner from '../cta_banner/cta_banner';
import AddProductForm from '../forms/add_product_form';
import RecommendedProducts from '../recommended_products/recommended_products';
import ExpandableBlock from '../expandable_block/expandable_block';
import Testimonials from '../testimonials/testimonials';
import Variant from './variant';
import { getInitialSelectedOptions } from '../utilities';

import { createProductQuery } from '../queries';
import { htmlDecode, slugify } from '../helpers.js';

import './product.css';

var _ref2 = React.createElement(
	'span',
	{ className: 'starting-at' },
	'Starting at:'
);

var _ref3 = React.createElement(
	'div',
	{ className: 'section-title wrapper' },
	React.createElement(
		'h2',
		null,
		'Testimonial'
	)
);

var _ref4 = React.createElement(
	'div',
	{ className: 'loading' },
	'Loading...',
	React.createElement(
		'div',
		{ className: 'loader' },
		React.createElement('span', { className: 'inner1' }),
		React.createElement('span', { className: 'inner2' }),
		React.createElement('span', { className: 'inner3' })
	)
);

var Showcase = function (_Component) {
	_inherits(Showcase, _Component);

	function Showcase() {
		_classCallCheck(this, Showcase);

		var _this = _possibleConstructorReturn(this, (Showcase.__proto__ || Object.getPrototypeOf(Showcase)).call(this));

		_this.state = {
			testimonials: [],
			selectedOptions: {},
			selectedVariant: {
				priceV2: {}
			},
			product: {},
			quantity: "0"

		};

		return _this;
	}

	_createClass(Showcase, [{
		key: 'createProductQuery',
		value: function createProductQuery(handle) {
			return gql(_templateObject, handle);
		}

		// TODO - refactor this to use this one and the one in kit builder as the same method in utilities

	}, {
		key: 'parseProductDescriptionDetails',
		value: function parseProductDescriptionDetails(description) {
			var details = description.split('[[SHOWCASE]]')[1];
			return details ? JSON.parse(details) : {};
		}
	}, {
		key: 'parseProductDescription',
		value: function parseProductDescription(description) {
			var desc = description.split('[[SHOWCASE]]')[0];
			return desc ? desc : "";
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var product_details = this.parseProductDescriptionDetails(this.props.parentProduct.description);
			fetch('/pages/testimonials').then(function (res) {
				return res.text();
			}).then(function (data) {
				var testimonials = JSON.parse(data.split('[[START]]')[1].split('[[END]]')[0]).testimonials.filter(function (item) {
					return item.product === product_details.product;
				});
				_this2.setState({
					testimonials: testimonials
				});
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var parentProduct = this.props.parentProduct;

			var product_details = this.parseProductDescriptionDetails(parentProduct.description);
			var description = this.parseProductDescription(parentProduct.description);
			return React.createElement(
				Query,
				{
					query: this.createProductQuery(product_details.product),
					onCompleted: function onCompleted(data) {} },
				function (_ref) {
					var loading = _ref.loading,
					    err = _ref.err,
					    data = _ref.data;

					if (!loading) {
						var product = data.productByHandle;
						return React.createElement(
							'div',
							{ className: 'simple-product simple-product-showcase' },
							React.createElement(
								'header',
								{ className: 'wrapper' },
								React.createElement(
									'div',
									null,
									React.createElement(
										'h1',
										null,
										product.title
									),
									React.createElement(
										'h2',
										null,
										product.productType
									)
								),
								React.createElement(
									'div',
									{ className: 'price' },
									React.createElement(
										'span',
										null,
										_ref2,
										React.createElement(
											'span',
											null,
											React.createElement(
												'strong',
												null,
												'$',
												Number(product.priceRange.minVariantPrice.amount).toFixed(0)
											),
											product.priceRange.minVariantPrice.currencyCode
										)
									)
								)
							),
							React.createElement(CTAGallery, {
								image: parentProduct.images.edges[0],
								cta: product_details.image_cta
							}),
							React.createElement(CTABanner, {
								cta: product_details.cta
							}),
							React.createElement(
								'div',
								{ className: 'gallery-showcase wrapper' },
								React.createElement(
									'div',
									null,
									React.createElement('img', { src: parentProduct.images.edges[1].node.productImg }),
									React.createElement(
										'div',
										null,
										React.createElement(
											'h2',
											null,
											product_details.description.title
										),
										React.createElement('div', { className: 'gallery-showcase-description', dangerouslySetInnerHTML: { __html: htmlDecode(product_details.description.content) } })
									)
								),
								React.createElement(
									'div',
									{ className: 'image-grid' },
									parentProduct.images.edges.map(function (image, index) {
										if (index > 1) {
											return React.createElement('img', { src: image.node.squareImg });
										}
									})
								)
							),
							_ref3,
							React.createElement(Testimonials, {
								testimonials: _this3.state.testimonials
							}),
							React.createElement(RecommendedProducts, {
								products: product_details.recommended_products,
								sectionTitle: 'true'
							})
						);
					} else {
						return _ref4;
					}
				}
			);
		}
	}]);

	return Showcase;
}(Component);

export default Showcase;

// onCompleted={data => this.setInitialData(data)}